/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrganizationBillingDetailDtoBase
 * auto generated base class for the model OrganizationBillingDetailDtoModel.
 */
export const OrganizationBillingDetailDtoModelBase = ModelBase
  .named('OrganizationBillingDetailDto')
  .props({
    __typename: types.optional(types.literal("OrganizationBillingDetailDto"), "OrganizationBillingDetailDto"),
    /** Comprised of organization uuid */
    id: types.identifier,
    name: types.union(types.undefined, types.string),
    status: types.union(types.undefined, types.string),
    currentPeriodStart: types.union(types.undefined, types.null, types.string),
    currentPeriodEnd: types.union(types.undefined, types.null, types.string),
    currentPeriodUsage: types.union(types.undefined, types.null, types.number),
    usageLimit: types.union(types.undefined, types.null, types.number),
    cancellationRequested: types.union(types.undefined, types.null, types.boolean),
    cancelAt: types.union(types.undefined, types.null, types.string),
    canceledAt: types.union(types.undefined, types.null, types.string),
    currentCycleSmsMessageCount: types.union(types.undefined, types.null, types.integer),
    currentCycleSmsSegmentCount: types.union(types.undefined, types.null, types.integer),
    smsAddonActive: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationBillingDetailDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get status() { return this.__attr(`status`) }
  get currentPeriodStart() { return this.__attr(`currentPeriodStart`) }
  get currentPeriodEnd() { return this.__attr(`currentPeriodEnd`) }
  get currentPeriodUsage() { return this.__attr(`currentPeriodUsage`) }
  get usageLimit() { return this.__attr(`usageLimit`) }
  get cancellationRequested() { return this.__attr(`cancellationRequested`) }
  get cancelAt() { return this.__attr(`cancelAt`) }
  get canceledAt() { return this.__attr(`canceledAt`) }
  get currentCycleSmsMessageCount() { return this.__attr(`currentCycleSmsMessageCount`) }
  get currentCycleSmsSegmentCount() { return this.__attr(`currentCycleSmsSegmentCount`) }
  get smsAddonActive() { return this.__attr(`smsAddonActive`) }
}
export function selectFromOrganizationBillingDetailDto() {
  return new OrganizationBillingDetailDtoModelSelector()
}

export const organizationBillingDetailDtoModelPrimitives = selectFromOrganizationBillingDetailDto().name.status.currentPeriodStart.currentPeriodEnd.currentPeriodUsage.usageLimit.cancellationRequested.cancelAt.canceledAt.currentCycleSmsMessageCount.currentCycleSmsSegmentCount.smsAddonActive
